/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Crm_Expects_OfflineInputs */

const cs_portals_crm_expects_offline = /** @type {(inputs: Portals_Crm_Expects_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

const en_portals_crm_expects_offline = /** @type {(inputs: Portals_Crm_Expects_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline`)
};

/**
* | output |
* | --- |
* | "Offline" |
*
* @param {Portals_Crm_Expects_OfflineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_crm_expects_offline = /** @type {((inputs?: Portals_Crm_Expects_OfflineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Crm_Expects_OfflineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_crm_expects_offline(inputs)
	return cs_portals_crm_expects_offline(inputs)
});